import moment from 'moment';
import i18n from '@/i18n';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES_LIST } from '@/constants/locales';


function normalizeLang(language) {
    if (!language) 
        return DEFAULT_LANGUAGE;
    const l = language.toLowerCase().replace('_', '-');
    if (l === 'en') 
        return 'en-gb'; 
    return l;
};

const rawSavedLanguage = localStorage.getItem('i18n_lang');
const isValidLanguage = SUPPORTED_LANGUAGES_LIST.includes(rawSavedLanguage);
const resolvedLanguage = isValidLanguage ? rawSavedLanguage : DEFAULT_LANGUAGE;
moment.locale(normalizeLang(resolvedLanguage));


i18n.on("languageChanged", (language) => {
    moment.locale(normalizeLang(language))
})
export default moment;


// WEBPACK FOOTER //
// ./src/moment/moment.js